import { FunctionComponent } from 'react';
import { FormProps } from 'antd/lib/form';
import styled from 'styled-components';
import { Form } from 'antd';

export const ArchivedSearchFormStyled: FunctionComponent<FormProps> = styled(Form)`
  margin-bottom: 1rem;

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
